<script lang="ts" setup>
import {useLoadingNotification} from '@/ts/composables/pure/use-loading-notification';
import {useApi} from '@/ts/composables/stateful/use-api';
import {useRouterSectionParams} from '@/ts/composables/stateful/use-route-params';
import {useRouter} from 'vue-router';
import {pagesPath} from '@/ts/router/pages-path';
import {SHOW_WITHDRAW_BTN} from '@/ts/utils/consts';
import {useScreenSize} from '@/ts/composables/stateful/use-screen-size';
import {useUserStore} from '@/ts/store/user-store';
import {storeToRefs} from 'pinia';
import {computed} from 'vue';

const api = useApi();
const {isDesktopResolution} = useScreenSize();
const userStore = useUserStore();
const {homeContent} = storeToRefs(userStore);

const {iid} = useRouterSectionParams();
const router = useRouter();

// Check if user is enrolled in the current intervention
const isEnrolledInCurrentPath = computed(() => {
  return homeContent.value?.currentIntervention?.interventionId === iid.value;
});

const [submit, loading] = useLoadingNotification(
  async() => {
    await api.me.withdrawIntervention(iid.value);
    // Refresh home content to reflect the withdrawal
    const updatedHomeContent = await api.me.getHomeContent();
    userStore.setHomeContent(updatedHomeContent);
  },
  () => void router.push(pagesPath.intervention.interventionsList),
);

</script>
<template>
  <q-item
    v-if="SHOW_WITHDRAW_BTN && iid && isEnrolledInCurrentPath"
    class="withdraw-btn text-body-bold"
    :dense="isDesktopResolution"
    :disable="loading || undefined"
    clickable
    @click="submit"
  >
    {{ $t('withdraw_interven') }}
  </q-item>
</template>
<style lang="scss" scoped>
.withdraw-btn {
  align-items: center;
  @include focus-visible;
  
  @include screen-lg {
    border-radius: var(--button-border-radius);
  }
}
</style>
